export default __webpack_public_path__ + "static/media/teaser1small.d6a5296e.jpg";